export default {
  TMZ: {
    UTC: -4,
  },
  ENV: {
    PROD: 'production',
    DEV: 'development',
  },
  SERVICES: {
    API_AUTH: 'AUTH',
    API_APP: 'API-PILOTO',
  },
  HTTP: {
    CODES: {
      OK: 200,
      INTERNAL_SERVER_ERROR: 500,
      NOT_FOUND: 404,
    },
  },
  VALUES: {
    VALUE_DOCUMENT: '20000',
  },
  RESPONSES: {
    DOCUMENTS: {
      GET: {
        SUCCESS: 'Document obtained successfully.',
        ERROR: 'Error obtaining the document.',
      },
      STORE: {
        SUCCESS: 'Document stored successfully.',
        ERROR: 'Error storing the document.',
      },
      ADDANNEX: {
        SUCCESS: 'Annex added successfully.',
        ERROR: 'Error adding annex to the contract.',
      },
      HISTORY: {
        SUCCESS: 'Document history obtained successfully.',
        ERROR: 'Error obtaining the document history.',
      },
      DOWNLOAD: {
        SUCCESS: 'Document downloaded successfully.',
        ERROR: 'Error downloading the document.',
      },
      SIGNCONTRACT: {
        SUCCESS: 'Document signed successfully.',
        ERROR: 'Error signing the document',
      },
      SIGNANNEX: {
        SUCCESS: 'Annex signed successfully.',
        ERROR: 'Error signing the annex',
      },
    },
    USERS: {
      REGISTER: {
        SUCCESS: 'User registered successfully.',
        ERROR: 'Error registering the user.',
      },
      LOGIN: {
        SUCCESS: 'User logged in successfully.',
        ERROR: 'Error logging in the user.',
      },
      DOCUMENTS: {
        SUCCESS: 'User documents obtained successfully.',
        ERROR: 'Error obtaining the user documents.',
      },
    },
    AXIOS: {
      ERROR: 'Error connecting to the endpoint.',
    },
    AUTH: {
      ERROR: 'Error, couldnt validate given token',
    },
  },
};